import React, { useState, useEffect } from "react";
import { StyledText } from "../../../../components/common";

const NewUpdateReleaseTimer = ({
  releaseDate,
  releaseTime,
  onHandleIsTime,
}) => {
  const [days, setDays] = useState("-");
  const [hours, setHours] = useState("--");
  const [minutes, setMinutes] = useState("--");
  const [seconds, setSeconds] = useState("--");

  const getFormattedValue = (value, isDay = false) => {
    if (isDay) return value.toString();
    return value < 10 ? `0${value}` : value;
  };

  useEffect(() => {
    if (!releaseDate || !releaseTime) return;

    const [day, month, year] = releaseDate.split("-").map(Number);
    const [hoursPart, minutesPart, secondsPart] = releaseTime
      .split(":")
      .map(Number);
    const targetTime = new Date(
      year,
      month - 1,
      day,
      hoursPart,
      minutesPart,
      secondsPart
    ).getTime();

    if (isNaN(targetTime)) {
      console.error("Invalid release date-time format");
      return;
    }

    const updateCountdown = () => {
      const now = new Date().getTime();
      let timeLeft = targetTime - now;

      if (timeLeft <= 0) {
        setDays("0");
        setHours("00");
        setMinutes("00");
        setSeconds("00");
        onHandleIsTime(true);
        return;
      }

      const remainingDays = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      timeLeft -= remainingDays * (1000 * 60 * 60 * 24);

      const remainingHours = Math.floor(timeLeft / (1000 * 60 * 60));
      timeLeft -= remainingHours * (1000 * 60 * 60);

      const remainingMinutes = Math.floor(timeLeft / (1000 * 60));
      timeLeft -= remainingMinutes * (1000 * 60);

      const remainingSeconds = Math.floor(timeLeft / 1000);

      setDays(getFormattedValue(remainingDays, true));
      setHours(getFormattedValue(remainingHours));
      setMinutes(getFormattedValue(remainingMinutes));
      setSeconds(getFormattedValue(remainingSeconds));
    };

    updateCountdown();
    const timerInterval = setInterval(updateCountdown, 1000);

    return () => clearInterval(timerInterval);
  }, [releaseDate, releaseTime, onHandleIsTime]);

  return (
    <>
      <StyledText style={{ fontFamily: "MTNRegular" }}>
        Coming soon in{" "}
        <span style={{ fontWeight: "700" }}>
          {days}d : {hours}h : {minutes}m : {seconds}s
        </span>
      </StyledText>
    </>
  );
};

export default NewUpdateReleaseTimer;
